module.exports = __webpack_public_path__ + "img/step12.95aa4f93.png";